// extracted by mini-css-extract-plugin
module.exports = {"gt-btn":"GreyTextBtn_gt-btn__Xnk5h"};